import { useCallback } from "react";

//HOCs
import { withUserContext, withUIContext } from 'context'
import { US, AM, RU } from 'country-flag-icons/react/3x2'

//* Components
import { ButtonSimple, FormContainer, Select } from "components/common";

const ChangeSettings = (props) => {

    const onFinish = useCallback((values) => {
        return props.changeSettings(values)
    }, [])

    return (
        <FormContainer initialValues={{
            language: props.language || 'en',
            isPublic: props.isPublic
        }} onFinish={onFinish}>
            <div className={'flexBoxColumn'}>
                <Select
                    label={'Language'}
                    name={'language'}
                    optionKey={'label'}
                    optionValue={'value'}
                    list={[
                        { label: <><US title="United States" className="flag" /> English</>, value: 'en' },
                        { label: <><RU title="Russia" className="flag" /> Russian</>, value: 'ru' },
                        { label: <><AM title="Armenia" className="flag" /> Armenian</>, value: 'hy' },
                    ]}
                />
                <Select
                    label={'Profile Visibility'}
                    name={'isPublic'}
                    optionKey={'label'}
                    optionValue={'value'}
                    list={[
                        { label: 'Visible to everyone', value: true },
                        { label: 'Visible for my followers', value: false }
                    ]}
                />
            </div>
            <div className="buttons flexBox spaceBetween alignEnd">
                <ButtonSimple className="save-btn" submit text="Save" />
                <ButtonSimple onClick={() => {
                    props.toggleDeactivatePopup()
                    props.disableDomScroll()
                }} className="deactivate-btn red" text="Deactivate profile" />
            </div>
        </FormContainer>
    )
}

export default withUserContext(withUIContext(ChangeSettings, ['toggleDeactivatePopup', 'disableDomScroll']), ['changeSettings'])